"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _ArrowUpOutlined = _interopRequireDefault(require("@ant-design/icons-svg/lib/asn/ArrowUpOutlined"));

var _AntdIcon = _interopRequireDefault(require("../components/AntdIcon"));

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(_AntdIcon.default, Object.assign({}, props, {
    ref: ref,
    icon: _ArrowUpOutlined.default
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';

var _default = /*#__PURE__*/React.forwardRef(ArrowUpOutlined);

exports.default = _default;